// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12E6P","type":"styles_type__VZAFW","choices":"styles_choices__SuO-f"};